<template>
    <BaseTableColumn :showEdit="!isEmpty"
                     :readOnly="readOnly"
                     :adUnit="adUnit"
                     :placementId="placement.id"
                     name="CappingPacing"
                     @edit="$emit('edit')"
                     @add="$emit('add')">
        <!-- Capping -->
        <div class="data-row" v-if="deliveryEnabled && (capping.enabled || defaultCapping.enabled)">
            <div v-if="capping.enabled && cappingOverridden">
                <label>Capping</label>
                <span class="font-4">{{ capping.maxImpressions }}/{{ getUnitName(capping.unit) }}</span>
            </div>
            <div v-if="defaultCapping.enabled" :class="{ overridden: cappingOverridden }" class="inactive">
                <label>Capping{{'&nbsp;'.repeat(3)}}</label>
                <span class="font-4">{{ defaultCapping.maxImpressions }}/{{ getUnitName(defaultCapping.unit) }}</span>
            </div>
        </div>
        <!-- Pacing -->
        <div class="data-row" v-if="deliveryEnabled && (pacing.enabled || defaultPacing.enabled)">
            <div v-if="pacing.enabled && pacingOverridden">
                <label>Pacing</label>
                <span class="font-4">1 Ad/{{ pacing.numOfMinutes }}min</span>
            </div>
            <div v-if="defaultPacing.enabled" :class="{ overridden: pacingOverridden }" class="inactive">
                <label>Pacing{{'&nbsp;'.repeat(6)}}</label>
                <span class="font-4">1 Ad/{{ defaultPacing.numOfMinutes.toFixed(1)}}min</span>
            </div>
        </div>
        <!-- Delivery disabled -->
        <div v-if="deliveryDisabled">
            <span class="negative">Ad Delivery Switched Off</span>
        </div>
        <!-- Empty -->
        <div v-if="isEmpty">
            - - -
        </div>
    </BaseTableColumn>
</template>

<script>
import consts from 'services/metaData/consts';
import BaseTableColumn from '@/pages/monetize/segments/segmentForm/columns/BaseTableColumn.vue';

export default {
    name: 'CappingPacingColumn',
    components: {
        BaseTableColumn
    },
    props: {
        placement: {
            type: Object,
            default: () => ({})
        },
        exception: {
            type: Object,
            default: () => ({})
        },
        readOnly: Boolean,
        adUnit: String
    },
    methods: {
        getUnitName(unit) {
            return consts.UNIT_NAMES[unit] || unit;
        }
    },
    computed: {
        deliveryDisabled() {
            return this.exception.enabled !== undefined && Number(this.exception.enabled) === 0;
        },
        deliveryEnabled() {
            return !this.deliveryDisabled;
        },
        capping() {
            return this.exception.capping || {};
        },
        pacing() {
            return this.exception.pacing || {};
        },
        defaultCapping() {
            return this.placement.capping || {};
        },
        defaultPacing() {
            return this.placement.pacing || {};
        },
        isEmpty() {
            const hasCapping = this.capping.enabled || this.defaultCapping.enabled;
            const hasPacing = this.pacing.enabled || this.defaultPacing.enabled;
            const hasDeliveryActive = this.exception.enabled !== undefined;
            return !hasDeliveryActive && !hasCapping && !hasPacing;
        },
        cappingOverridden() {
            if (Object.keys(this.capping).length === 0) return false;

            return this.capping.enabled !== this.defaultCapping.enabled
                || this.capping.maxImpressions !== this.defaultCapping.maxImpressions
                || this.capping.unit !== this.defaultCapping.unit;
        },
        pacingOverridden() {
            if (Object.keys(this.pacing).length === 0) return false;

            return this.pacing.numOfMinutes !== this.defaultPacing.numOfMinutes
                || this.pacing.enabled !== this.defaultPacing.enabled;
        },
        consts: () => consts
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
@import "~styles/buttons.scss";

label {
    min-width: 58px;
    display: inline-block;
    text-decoration: inherit;
    font-weight: normal;
}

.data-row {
    display: flex;
    > div:first-child {
        width: 146px;
        margin-right: 15px;
    }
}

.negative {
    color: $negative;
}

.inactive {
    color: $light-800;
}

.overridden {
    text-decoration: line-through;
}
</style>
